module.exports = __webpack_public_path__ + "img/copykat.80296fb0.png";